import { CustomerItem, CustomerListRst } from "../types/customer";
import {
  CustomInfoList,
  PosCustomerInfo,
  PosUserEyeInfo,
  PosUserEyeInfoFormData,
  UpdatePosCustomerData,
  UserFormData,
} from "../types/user";
import { get, post } from "./fetch.core";

export async function getPosCustomers({ search, page, pageSize }: { search?: string; page?: number; pageSize?: number }) {
  const res = await post<CustomerListRst>("/pos/user/listWithSize", {
    search,
    paging: {
      page: page || 1,
      size: pageSize || 30,
    },
  });

  return res.data;
}

export async function getPosCustomer(id: string) {
  const res = await get<CustomerItem>(`/pos/user/single?id=${id}`);
  return res.data;
}

export async function getPosGuestCustomers() {
  const res = await get<CustomerItem>("/pos/guestUser/get");
  return res.data;
}

export async function createPosCustomer(data: UserFormData) {
  //  @ts-ignore
  if (data.email.length < 1) delete data.email;
  //  @ts-ignore
  if (data.mobileNumber.length < 1) delete data.mobileNumber;

  const res = await post<{ message: string; userId: string }>("/pos/user/create", {
    ...data,
    countryCode: "852",
    telCountryCode: "852",
  });

  return res.data;
}

export async function updatePosCustomer(data: UpdatePosCustomerData) {
  if (!data.email) delete data.email;
  if (!data.mobileNumber) delete data.mobileNumber;

  const res = await post<any>("/pos/user/edit", data);

  return res.data;
}

export async function editCustomerEyeInfo({ userId, data }: { userId: string; data: PosUserEyeInfo }) {
  const res = await post<any>("/pos/customerInfo/edit", {
    eyeInfo: [
      {
        ...data,
      },
    ],
    userId,
  });
  return res.data;
}

export async function getCustomerInfo(userId: any) {
  const res = await get<PosCustomerInfo | null>(`/pos/customerInfo/get?userId=${userId}`);

  return res.data;
}

export async function getPosUserOrders(id: any) {
  const res = await get<any>(`/pos/user/orders/${id}`);

  return res.data;
}

export async function listCustomerInfoRecords(userId: string) {
  const res = await post<CustomInfoList>("/pos/customerInfo/list", { userId });

  return res.data;
}

export async function getCustomerEyeInfo({ id, userId }: { id: string; userId: string }) {
  const res = await get<{ eyeInfo: PosUserEyeInfo }>(`/pos/customerInfo/singleEyeInfo?eyeInfoId=${id}&userId=${userId}`);

  return res.data;
}

export async function deleteCustomerEyeInfo({ id }: { id: string }) {
  const res = await post<any>("/pos/customerInfo/deleteEyeInfo", { id });

  return res.data;
}

export async function updateCustomerEyeInfo({ eyeInfoId, data }: { eyeInfoId: string; data: PosUserEyeInfoFormData }) {
  const payload = {
    id: eyeInfoId,
    habRxSphLeft: data.habRxSphLeft,
    habRxSphRight: data.habRxSphRight,
    habRxCylLeft: data.habRxCylLeft,
    habRxCylRight: data.habRxCylRight,
    habRxAxisLeft: data.habRxAxisLeft,
    habRxAxisRight: data.habRxAxisRight,
    habRxVaLeft: data.habRxVaLeft,
    habRxVaRight: data.habRxVaRight,
    habRxAddLeft: data.habRxAddLeft,
    habRxAddRight: data.habRxAddRight,
    habRxPrismLeft: data.habRxPrismLeft,
    habRxPrismRight: data.habRxPrismRight,
    habRxPDRight: data.habRxPDRight,
    habRxPDLeft: data.habRxPDLeft,
    habRxHeightRight: data.habRxHeightRight,
    habRxHeightLeft: data.habRxHeightLeft,
    fullRxSphLeft: data.fullRxSphLeft,
    fullRxSphRight: data.fullRxSphRight,
    fullRxCylLeft: data.fullRxCylLeft,
    fullRxCylRight: data.fullRxCylRight,
    fullRxAxisLeft: data.fullRxAxisLeft,
    fullRxAxisRight: data.fullRxAxisRight,
    fullRxVaLeft: data.fullRxVaLeft,
    fullRxVaRight: data.fullRxVaRight,
    fullRxAddLeft: data.fullRxAddLeft,
    fullRxAddRight: data.fullRxAddRight,
    fullRxPrismLeft: data.fullRxPrismLeft,
    fullRxPrismRight: data.fullRxPrismRight,
    fullRxPDRight: data.fullRxPDRight,
    fullRxPDLeft: data.fullRxPDLeft,
    fullRxHeightRight: data.fullRxHeightRight,
    fullRxHeightLeft: data.fullRxHeightLeft,
    adjustedRxSphLeft: data.adjustedRxSphLeft,
    adjustedRxSphRight: data.adjustedRxSphRight,
    adjustedRxCylLeft: data.adjustedRxCylLeft,
    adjustedRxCylRight: data.adjustedRxCylRight,
    adjustedRxAxisLeft: data.adjustedRxAxisLeft,
    adjustedRxAxisRight: data.adjustedRxAxisRight,
    adjustedRxVaLeft: data.adjustedRxVaLeft,
    adjustedRxVaRight: data.adjustedRxVaRight,
    adjustedRxAddLeft: data.adjustedRxAddLeft,
    adjustedRxAddRight: data.adjustedRxAddRight,
    adjustedRxPrismLeft: data.adjustedRxPrismLeft,
    adjustedRxPrismRight: data.adjustedRxPrismRight,
    adjustedRxPDRight: data.adjustedRxPDRight,
    adjustedRxPDLeft: data.adjustedRxPDLeft,
    adjustedRxHeightRight: data.adjustedRxHeightRight,
    adjustedRxHeightLeft: data.adjustedRxHeightLeft,
    optometrist: data.optometristId,
    remarks: data.remarks,
  };

  if (!payload.optometrist) delete payload.optometrist;

  const res = await post<any>("/pos/customerInfo/updateEyeInfo", payload);

  return res.data;
}

export async function updateCustomerProfileInfo({ userId, profileInfo }: { userId: string; profileInfo: { age?: string } }) {
  const res = await post<any>("/pos/customerInfo/edit", {
    userId,
    profileInfo,
  });
  return res.data;
}
